import { useDataAttributes } from '@lumapps/data-attributes';

import { SCOPE } from '../../constants';

export const usePlayDataAttributes = () => useDataAttributes(SCOPE);
